/**
 * 半角英数字に変換
 * @param str
 * @returns {string}
 */
export function toOneByte (str) {
  str = String(str)
  return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
  })
}

/**
 * 半角数字に変換
 * @param num
 * @returns {string}
 */
export function toSingleNumber (num) {
  num = String(num)
  let val0 = num.replace(/[^\-０-９0-9]/g, '')
    .replace(/^[0０]+/, '')
  return toOneByte(val0)
}

/**
 * 数値にカンマ区切り表記
 * @param num
 * @param showZeroIfEmpty
 */
export function addComma (num, showZeroIfEmpty = true) {
  let val = toSingleNumber(num)
  val = val.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
  if (showZeroIfEmpty === true && val === '') {
    val = '0'
  }
  return val
}

export function nl2br(str) {
  str = str.replace(/\r\n/g, "<br>");
  str = str.replace(/(\n|\r)/g, "<br>");
  return str;
}